// 🔴 TRAD-3790 — 반드시 첫 import: 애플 콜백 code 를 계측(firebase)·라우터보다 먼저 주소창에서 지운다.
import '@/shared/lib/auth/apple-android-callback-capture';
import { createRoot } from 'react-dom/client';

import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';

import App from './App';
import { syncDocumentLang } from '@/i18n';
import { removePrerenderedHead } from '@/shared/lib/seo/prerendered-head';
import '@/shared/configs/firebase';
import { resolveWwwApexRedirectUrl } from '@/shared/lib/utils/www-apex-redirect';
import { captureLandingCampaign } from '@/shared/lib/store-attribution';

import './index.css';

// TRAD-2219 — ag-grid-community v33부터 모듈을 명시적으로 등록해야 그리드가 렌더된다
// (v32까지는 `ag-grid-community` 패키지 자체가 암묵적으로 전부 등록했다). 미등록 시
// "AG Grid: error #200 Missing module ClientSideRowModelModule" 로 그리드가 완전히
// 빈 채로 렌더된다(실 브라우저 검증 스크립트 verify-trad2212-pinned-race.cjs로 실측 확인).
// AllCommunityModule로 기존과 동일하게 전체 등록해, 이 앱의 그리드 화면 3곳
// (시세 /market, 파생 랭킹, 관심종목)이 전부 동일하게 계속 동작하게 한다.
ModuleRegistry.registerModules([AllCommunityModule]);

// TRAD-2546 임시 완화 — www.xtrading.kr 에서 구글 로그인이 실패한다(GSI 위젯의 origin
// 검사가 www 를 허용하지 않음, 실측 2026-08-13). 근본 처방은 nginx 의 www→apex 301
// 정규화(A안, davidyoon 승인 대기 중).
// 🔴 nginx 301 이 적용되면 이 블록(과 resolveWwwApexRedirectUrl/그 테스트)을 통째로
// 삭제한다 — 그때부터 www 요청 자체가 nginx 에서 걸러져 이 코드는 절대 실행되지 않는다.
// 🔴 TRAD-3253 — index.html 의 `lang="ko"` 는 프리렌더(한국어 본문) 기준이라 정적 파일에서는
// 맞다. 하이드레이션 시점에 실제 로케일로 옮긴다 — 안 하면 EN 사용자 문서가 계속 ko 다.
syncDocumentLang();

const wwwApexRedirectUrl = resolveWwwApexRedirectUrl(window.location);
if (wwwApexRedirectUrl) {
  window.location.replace(wwwApexRedirectUrl);
} else {
  // TRAD-3653 — prerender 가 굳힌 페이지 head 태그를 렌더 전에 지운다(런타임 PageMeta 와 두 벌 방지).
  removePrerenderedHead();
  // TRAD-3711 — 첫 진입 URL 의 utm_campaign(허용 목록만)을 세션에 기억 → 스토어 버튼 추적 이름(store-attribution.ts).
  captureLandingCampaign(window.location.search);
  createRoot(document.getElementById('root')!).render(<App />);
}
